if (!customElements.get('aw-collection-menu')) {
  customElements.define('aw-collection-menu', class extends HTMLElement {
    connectedCallback() {
      if (this.cleanup) this.cleanup();
      const menu = this.querySelector('.aw-dropdown');
      const panel = this.querySelector('.aw-dropdown-panel');
      const dialog = this.querySelector('.aw-menu-dialog');
      if (!menu || !panel || !dialog) return;
      const controller = new AbortController();
      const signal = controller.signal;
      const mobile = matchMedia('(max-width: 749px)');
      const trigger = menu.querySelector(':scope > summary');
      const closeButton = panel.querySelector('[data-aw-menu-close]');
      let scrollLock = null;
      const unlock = () => {
        if (!scrollLock) return;
        Object.assign(document.body.style, scrollLock.styles);
        window.scrollTo(0, scrollLock.y);
        scrollLock = null;
      };
      const lock = () => {
        if (scrollLock) return;
        const style = document.body.style;
        scrollLock = { y: window.scrollY, styles: { position: style.position, top: style.top, left: style.left, right: style.right, width: style.width, overflow: style.overflow } };
        Object.assign(style, { position: 'fixed', top: '-' + scrollLock.y + 'px', left: '0', right: '0', width: '100%', overflow: 'hidden' });
      };
      const sync = () => {
        if (menu.open && mobile.matches) {
          if (panel.parentElement !== dialog) dialog.append(panel);
          if (!dialog.open) {
            lock();
            dialog.showModal();
            panel.scrollTop = 0;
            closeButton.focus({ preventScroll: true });
          }
        } else {
          if (dialog.open) dialog.close();
          if (panel.parentElement !== menu) menu.insertBefore(panel, dialog);
          unlock();
        }
      };
      const close = () => {
        menu.open = false;
        sync();
        trigger.focus({ preventScroll: true });
      };
      menu.addEventListener('toggle', () => {
        if (!menu.open) panel.querySelectorAll('details[open]').forEach(item => { item.open = false; });
        sync();
      }, { signal });
      closeButton.addEventListener('click', close, { signal });
      dialog.addEventListener('cancel', event => { event.preventDefault(); close(); }, { signal });
      dialog.addEventListener('close', () => { if (mobile.matches && menu.open && !dialog.open) close(); }, { signal });
      panel.addEventListener('click', event => { if (event.target.closest('a')) close(); }, { signal });
      mobile.addEventListener('change', sync, { signal });
      sync();
      this.cleanup = () => { controller.abort(); if (dialog.open) dialog.close(); unlock(); };
    }
    disconnectedCallback() { if (this.cleanup) this.cleanup(); }
  });
}
